// SLIDER
const $slider = $('.js-slider');

$slider.on('init', () => {
    $slider.parent().css({ 'visibility': 'visible' });
});

$slider.slick({
    dots: true,
    arrows: true,
    lazyLoad: 'progressive',
    prevArrow: $('.fou__slider-btn--prev'),
    nextArrow: $('.fou__slider-btn--next'),
    variableWidth: false,
    responsive: [
        {
            breakpoint: 1460,
            settings: {
                variableWidth: true
            }
        },
        {
            breakpoint: 768,
            settings: {
                variableWidth: false,
                arrows: false
            }
        },
        {
            breakpoint: 540,
            settings: {
                variableWidth: true,
                arrows: false
            }
        }
    ]
});

// DEFAULT ACTION
$('.fou__popup-header span').not('.fou__popup-header span:first-child').hide();
$('.fou__popup-body-top span').not('.fou__popup-body-top span:first-child').hide();
$('.fou__popup-wrap').hide();

// DEFAULT EVENT ON CLICK BUTTON
$('.fou__popup-body-top').click( () => {
    $('.fou__popup-wrap').eq(0).toggle();
    $('.js-popup-btn').toggleClass('ic-reading');
    $('.js-popup-btn').toggleClass('ic-close');
});

// EVENT SLIDE
$slider.on('beforeChange', (event, slick, currentSlide, nextSlide) => {
    $('.fou__popup-header span').hide();
    $('.fou__popup-header span').eq(nextSlide).show();
    $('.fou__popup-body-top span').hide();
    $('.fou__popup-body-top span').eq(nextSlide).show();
    $('.fou__popup-wrap').hide();
    $('.js-popup-btn').addClass('ic-reading');
    $('.js-popup-btn').removeClass('ic-close');
    $('.fou__popup-body-top').off('click');

    // EVENT ON CLICK BUTTON AFTER SLIDE
    $('.fou__popup-body-top').click( () => {
        if($('.fou__popup-wrap').eq(nextSlide)) {
            $('.fou__popup-wrap').eq(nextSlide).toggle();
            $('.js-popup-btn').toggleClass('ic-reading');
            $('.js-popup-btn').toggleClass('ic-close');
        }
    });
});
